import dayjs from 'dayjs';
import { logEvent } from 'firebase/analytics';
import analytics from '../../firebase';

export function sendLogData({ title = 'arirang', id = '0', type = 'error' }) {
  logEvent(analytics, 'select_item', {
    item_list_name: title,
    item_list_id: `${type}_${id}`,
    items: [
      {
        item_id: id,
        item_name: title,
        item_brand: type,
      },
    ],
  });
}

export const getTimeStamp = () => {
  let ymdHms = dayjs.tz();
  let year = ymdHms.year();
  let month = ('0' + (ymdHms.month() + 1)).slice(-2);
  let day = ('0' + ymdHms.date()).slice(-2);

  let dateString = year + '-' + month + '-' + day;

  return dateString;
};

export const timeFnc = (data) => {
  let res;
  if (data) {
    let today = dayjs.tz().format('YYYY-MM-DD');
    let start =
      data.property.schedule[0].start_time?.toString().length === 3
        ? addColon('0' + data.property.schedule[0].start_time)
        : addColon(data.property.schedule[0].start_time);

    let end = dayjs
      .tz(today + start)
      .add(2, 'h')
      .format('HH:mm');

    res = `${start} ~ ${end} KST`;
  }
  return res;
};

export const addColon = (hm) => {
  const res = [hm?.toString().slice(0, 2), ':', hm?.toString().slice(2)].join('');
  return res;
};

export const program_sch = (scheduleData, tmrSchData, ystSchData) => {
  const nowhm = dayjs.tz().format('HHmm');
  let now = '';
  let nowobj = {};
  scheduleData?.responseBody?.dsSchWeek?.map((v, i, row) => {
    if (row.length !== i + 1 && i !== 0 && row.length - 1 === i) {
      if (
        nowhm.localeCompare(scheduleData?.responseBody?.dsSchWeek[i].broadHm) >= 0 &&
        nowhm.localeCompare(scheduleData?.responseBody?.dsSchWeek[i + 1].broadHm) < 0
      ) {
        now = v.broadHm;
      }
      if (v.broadHm === now) {
        nowobj = {
          prev: scheduleData?.responseBody?.dsSchWeek[i - 1],
          now: scheduleData?.responseBody?.dsSchWeek[i],
          next: scheduleData?.responseBody?.dsSchWeek[i + 1],
          second: scheduleData?.responseBody?.dsSchWeek[i + 2]
            ? scheduleData?.responseBody?.dsSchWeek[i + 2]
            : tmrSchData?.responseBody?.dsSchWeek[0],
          third: scheduleData?.responseBody?.dsSchWeek[i + 3],
        };
      }
      return null;
    } else if (row.length === i + 1) {
      if (nowhm.localeCompare(scheduleData?.responseBody?.dsSchWeek[i].broadHm) >= 0) {
        now = v.broadHm;
      }
      if (v.broadHm === now) {
        nowobj = {
          prev: scheduleData?.responseBody?.dsSchWeek[i - 1],
          now: scheduleData?.responseBody?.dsSchWeek[i],
          next: tmrSchData?.responseBody?.dsSchWeek[0],
          second: tmrSchData?.responseBody?.dsSchWeek[1],
          third: scheduleData?.responseBody?.dsSchWeek[2],
        };
      }
      return null;
    } else if (i === 0) {
      if (nowhm.localeCompare(scheduleData?.responseBody?.dsSchWeek[i + 1].broadHm) < 0) {
        now = v.broadHm;
      }
      if (v.broadHm === now) {
        nowobj = {
          prev: ystSchData?.responseBody?.dsSchWeek[parseInt(ystSchData?.responseBody?.dsSchWeek.length - 1)],
          now: scheduleData?.responseBody?.dsSchWeek[i],
          next: scheduleData?.responseBody?.dsSchWeek[1],
          second: scheduleData?.responseBody?.dsSchWeek[2],
          third: scheduleData?.responseBody?.dsSchWeek[3],
        };
      }
      return null;
    } else {
      if (
        nowhm.localeCompare(scheduleData?.responseBody?.dsSchWeek[i].broadHm) >= 0 &&
        nowhm.localeCompare(scheduleData?.responseBody?.dsSchWeek[i + 1].broadHm) < 0
      ) {
        now = v.broadHm;
      }
      if (v.broadHm === now) {
        nowobj = {
          prev: scheduleData?.responseBody?.dsSchWeek[i - 1],
          now: scheduleData?.responseBody?.dsSchWeek[i],
          next: scheduleData?.responseBody?.dsSchWeek[i + 1],
          second: scheduleData?.responseBody?.dsSchWeek[i + 2]
            ? scheduleData?.responseBody?.dsSchWeek[i + 2]
            : tmrSchData?.responseBody?.dsSchWeek[0],
          third: scheduleData?.responseBody?.dsSchWeek[i + 3]
            ? scheduleData?.responseBody?.dsSchWeek[i + 3]
            : tmrSchData?.responseBody?.dsSchWeek[1],
        };
      }
      return null;
    }
  });
  return nowobj;
};

export const calcDate = (date) => {
  let seconds = Math.floor((dayjs.tz() - dayjs.tz(date)) / 1000);

  let interval = seconds / 31536000;
  if (date) {
    if (interval > 1) {
      return `${date.slice(0, -2)} KST`;
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return `${date.slice(0, -2)} KST`;
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return `${date.slice(0, -2)} KST`;
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + ' hours ago';
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + ' min ago';
    }
    return Math.floor(seconds) + ' sec ago';
  }
};

// 153 -> "00:02:33"
export function secToTimeStr(intTime) {
  var hours = Math.floor(intTime / 3600);
  var minutes = Math.floor((intTime - hours * 3600) / 60);
  var seconds = intTime - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  return hours + ':' + minutes + ':' + seconds;
}

export function transHHmm(time) {
  const hour = String(Math.floor(time / 60)).padStart(2, '0');
  const minute = String(time % 60).padStart(2, '0');

  return `${hour}:${minute}`;
}
export function transHHmmss(time) {
  const hour = String(Math.floor(time / 3600)).padStart(2, '0');
  const minute = String(Math.floor((time % 3600) / 60)).padStart(2, '0');
  const second = String(time % 60).padStart(2, '0');

  return `${hour}:${minute}:${second}`;
}
